<template>
  <div class="calendar-setting">
    <Tablist
      :list="tabList"
      :active-id="activeIndex"
      @updateCurrentPage="updateCurrentPage"
    />
    <SetWorkingDay v-if="activeIndex == '0'" />
    <SetMonthlyDate v-if="activeIndex == '1'" />
  </div>
</template>
<script>
import Tablist from '@/components/toolbar/Tablist.vue'
import SetWorkingDay from '@/components/system/SetWorkingDay.vue'
import SetMonthlyDate from '@/components/system/SetMonthlyDate.vue'
export default {
  name: 'CalendarSetting',
  components: {
    Tablist,
    SetWorkingDay,
    SetMonthlyDate
  },
  data() {
    return {
      tabList: [
        { id: '0', directory_name: '设置店铺工作日' },
        { id: '1', directory_name: '设置人工月统计日期' }
      ],
      activeIndex: '0'
    }
  },
  methods: {
    updateCurrentPage(val) {
      this.activeIndex = val
    }
  }
}
</script>
